import PropTypes from 'prop-types';

const displayName = 'AdminInvoiceForm';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
